import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import SourceIntelligencePage from '@/components/source_intelligence/index_page.vue'

export default class extends Controller {
  static values = {
    payload: Object
  }

  connect() {
    this.vue = createApp(SourceIntelligencePage, {
      payload: this.payloadValue || {}
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
